import { gql } from '@apollo/client';

export const GET_UPGRADE_PATHS_QUERY = gql`
  query GetUpgradePaths {
    userV2 {
      ... on AuthenticatedUser {
        id
        email
        upgradePaths {
          bundle
          license_class
          license_type
          licensedproduct_id
          registered
          title
          upgrade_path {
            license_type
            licensedproduct_id
            title
          }
        }
      }
      __typename
    }
  }
`;

export const GET_BASE_PRODUCTS_MESSAGES = gql`
  query GetBaseProductsMessages($languages: [String], $sku: String!) {
    content {
      required_base_products(filter: { sku: { _eq: $sku } }) {
        sku
        messages(filter: { languages_code: { code: { _in: $languages } } }) {
          id
          required_base_products
          languages_code {
            code
          }
        }
      }
    }
  }
`;
